import EditProfileForm from './EditProfileForm'
import { useGetProfileQuery } from './usersApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

function Profile() {
    useTitle('geshtop-Exercise: Edit Profile')



    const {data:user} = useGetProfileQuery("profile", {

    })




   if (!user ) return <PulseLoader color={"#FFF"} />
   //console.log(process.env.REACT_APP_FILES_LOCATIONS)

    const content = <EditProfileForm user={user}  />

    return content
   
}

export default Profile